import { StatusIcon } from '@/components/icons/status-icon';

interface GeneralErrorProps {
  fallback?: string;
}

export const GeneralError = ({ fallback }: GeneralErrorProps) => (
  <div className="flex flex-col items-center justify-center gap-3 p-6">
    <StatusIcon success={false} className="h-12 w-auto" />
    <p className="text-gray-600">{fallback ?? 'Omlouváme se, při zpracovávání Vašeho požadavku došlo k chybě'}</p>
  </div>
);
